import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { isClientApp } from 'ziphy-web-shared/basic/helpers';
import { ShowMoreDetails } from 'ziphy-web-shared/basic/lib/functional';
import { DtlGroup, DtlItem } from 'ziphy-web-shared/basic/lib/simple';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import ActorProfileModal from '@library/actorProfile/ActorProfile.modal';
import { extendPlace } from '@helpers/addressHelper';
import hAppt from '@helpers/hAppt';
import styles from './ApptDetails.module.scss';
const ApptDetails = ({ byRoute, className }) => {
    const { t } = useTranslation();
    const { fullAppt, status } = byRoute;
    const { appointment, service, place, agent, provider, practice } = fullAppt;
    const usedTimezone = isClientApp() ? place.timezone : undefined;
    function openActorProfile(role) {
        $modal.add(ActorProfileModal, { byRoute, role });
    }
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: _jsxs(DtlGroup, Object.assign({ className: "row row--mb-10" }, { children: [_jsx(DtlItem, Object.assign({ className: "col-12 col-lg-6 col-xl-3", label: t('label.details') }, { children: _jsx(ShowMoreDetails, { items: [
                            { rightLabel: t('label.address'), value: extendPlace(place).address() },
                            ...(isClientApp()
                                ? [{ rightLabel: t('label.price'), value: hAppt.amount({ appointment }) }]
                                : []),
                            { rightLabel: t('label.appointment_id'), value: appointment.id },
                        ] }) })), _jsx(DtlItem, Object.assign({ className: "col-12 col-lg-6 col-xl-3", label: t('label.type') }, { children: _jsx(ShowMoreDetails, { items: [{ rightLabel: t('label.service_type'), value: service.name }] }) })), _jsx(DtlItem, Object.assign({ className: "col-12 col-lg-6 col-xl-3", label: t('label.date_&_time') }, { children: _jsx(ShowMoreDetails, { items: [
                            {
                                rightLabel: t('label.scheduled_time'),
                                value: formatDate(appointment.appointedStart, { timezone: usedTimezone }),
                            },
                            {
                                rightLabel: t('label.booked_time'),
                                value: formatDate(appointment.created, { timezone: usedTimezone }),
                            },
                            {
                                rightLabel: t('label.timezone'),
                                value: place.timezone,
                            },
                        ] }) })), _jsx(DtlItem, Object.assign({ className: "col-12 col-lg-6 col-xl-3", label: t('label.practice_&_staff') }, { children: _jsx(ShowMoreDetails, { items: [
                            { rightLabel: t('label.practice'), value: practice.name },
                            {
                                rightLabel: t('label.occ'),
                                value: !_.isEmpty(agent) && (isClientApp() ? true : !status.isShifted) ? (_jsx("div", Object.assign({ className: "a", onClick: () => openActorProfile('agent') }, { children: agent.name }))) : (t('label.none')),
                            },
                            {
                                rightLabel: t('label.provider'),
                                value: !_.isEmpty(provider) && (isClientApp() ? true : !status.isShifted) ? (_jsx("div", Object.assign({ className: "a", onClick: () => openActorProfile('provider') }, { children: provider.name }))) : (t('label.none')),
                            },
                        ] }) }))] })) })));
};
export default observer(ApptDetails);
